import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_3 = {
  class: "modal-content",
  style: {"border-radius":"15px"}
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header p-5\"><div class=\"d-flex gap-4 p-0 align-items-center\"><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><i style=\"height:fit-content;width:fit-content;font-size:18px;color:#203972 !important;\" class=\"m-0 fas fa-pencil-alt\"></i></div><div><p class=\"m-0 subtitulo cor_texto_1\">Bloquear loja</p><p class=\"m-0 legenda text-muted\">bloqueie o acesso a loja na api de produtos</p></div></div></div>", 1)
const _hoisted_5 = {
  class: "modal-body background_2",
  style: {},
  id: "modalBody"
}
const _hoisted_6 = { class: "d-flex flex-column gap-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Configurações", -1)
const _hoisted_8 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden w-100 background_1"
}
const _hoisted_9 = {
  class: "m-0 texto bold cor_texto_1 d-flex justify-content-between align-items-center px-5 gap-2 py-5 cursor-pointer",
  style: {"white-space":"nowrap"}
}
const _hoisted_10 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5 gap-4" }
const _hoisted_11 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "white",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("section", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, [
                _createTextVNode(" Bloquear lojas "),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.arrayLojasBloqueadas,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.arrayLojasBloqueadas) = $event)),
                  multiple: "",
                  filterable: "",
                  "collapse-tags": "",
                  placeholder: "Selecione um cargo..."
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayLojas, (loja) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: loja.codConcessionaria,
                        label: loja.nome,
                        value: loja.codConcessionaria
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.loadSalvar && _ctx.salvar())),
            style: {"height":"fit-content","white-space":"nowrap"},
            class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
          }, [
            (_ctx.loadSalvar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
              : (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16)),
            _createTextVNode(" Salvar ")
          ])
        ])
      ])
    ])
  ]))
}